import { z } from "zod";
import { RoleNoPasswordSchema } from "./permissions.js";
/**
 * Body of `POST /v1/auth/recover/inspect` and `POST /v1/auth/recover`: the
 * opaque token from a recovery link (32 random bytes, base64url ⇒ 43 chars).
 */
export const RecoveryTokenRequestSchema = z.object({
    token: z.string().min(16).max(128),
});
export const SignInRequestSchema = z.object({
    password: z.string().max(256),
});
export const RecoveryInspectResponseSchema = z.object({
    roleName: z.string(),
    expiresAt: z.number(),
});
export const SignOutResponseSchema = z.union([
    RoleNoPasswordSchema,
    z.object({ message: z.string() }),
]);
export const RecoveryRequestResponseSchema = z.object({
    success: z.literal(true),
    delivered: z.boolean().optional(),
});
